function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useReducer } from 'react';
import { colors } from '@material-ui/core';
import { ConfirmationModal, Typography } from 'seagull';
import { useGlobalContext } from "../../contexts";
import { useOnMount } from "../useOnMount";
import styles from "./useBulkActionModal.module.scss";
import { Checkmark, CloseLiner24 } from 'seagull/icons';
import pluralize from 'pluralize';
import { numberAndUnit } from "../../infra/utils";
export function useBulkActionModal() {
  const globalContext = useGlobalContext();
  async function doBulkAction(props) {
    const {
      bulkItemIds,
      confirmationContent,
      confirmationPrimaryButtonLabel,
      confirmationTitle,
      progressTitle,
      actionName,
      itemName,
      errorExtra,
      onConfirmed,
      canProcessItem,
      processSingleItem,
      onDone
    } = props;
    const confirmed = await globalContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: confirmationTitle,
          textAlignCenter: false,
          content: confirmationContent,
          primaryButtonLabel: confirmationPrimaryButtonLabel,
          secondaryButtonLabel: "Cancel",
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        });
      }
    });
    if (confirmed) {
      onConfirmed();
      await globalContext.showModal({
        content: function BulkActionModal(_ref2) {
          let {
            dismissModal
          } = _ref2;
          const [state, dispatch] = useReducer((state, action) => {
            switch (action.type) {
              case 'succeeded':
                return _objectSpread(_objectSpread({}, state), {}, {
                  succeeded: state.succeeded + 1
                });
              case 'failed':
                return _objectSpread(_objectSpread({}, state), {}, {
                  failed: state.failed.add(action.failedId),
                  errors: action.error != null ? state.errors.concat(action.error) : state.errors
                });
            }
          }, {
            succeeded: 0,
            failed: new Set([]),
            errors: []
          });
          useOnMount(() => {
            const sendSingleRequest = async itemId => {
              try {
                if (canProcessItem(itemId)) {
                  const [, error, isError] = await processSingleItem(itemId);
                  dispatch({
                    type: isError ? 'failed' : 'succeeded',
                    failedId: itemId,
                    error: error || null
                  });
                } else {
                  dispatch({
                    type: 'succeeded'
                  });
                }
              } catch (err) {
                dispatch({
                  type: 'failed',
                  failedId: itemId,
                  error: null
                });
              }
            };
            bulkItemIds.reduce((asyncChain, itemId) => asyncChain.then(() => sendSingleRequest(itemId)), Promise.resolve());
          });
          const closeModal = () => dismissModal(Array.from(state.failed.values()));
          return /*#__PURE__*/React.createElement(ConfirmationModal, {
            title: progressTitle,
            textAlignCenter: false,
            content: /*#__PURE__*/React.createElement("div", null, state.succeeded + state.failed.size < bulkItemIds.length ? /*#__PURE__*/React.createElement(Typography, null, "Sending ", pluralize(itemName, bulkItemIds.length), " (", state.succeeded + state.failed.size, "/", bulkItemIds.length, ")") : /*#__PURE__*/React.createElement(React.Fragment, null, state.succeeded > 0 && /*#__PURE__*/React.createElement("div", {
              className: styles.bulkRequestsResultSuccess
            }, /*#__PURE__*/React.createElement(Checkmark, null), ' ', /*#__PURE__*/React.createElement(Typography, {
              color: colors.green[900],
              skin: 'success',
              "data-testid": "bulk-succeeded-text"
            }, numberAndUnit(state.succeeded, itemName), " ", actionName, ' ', "successfully")), state.failed.size > 0 && /*#__PURE__*/React.createElement("div", {
              className: styles.bulkRequestsResultFailure
            }, /*#__PURE__*/React.createElement(CloseLiner24, null), ' ', /*#__PURE__*/React.createElement(Typography, {
              color: colors.green[900],
              skin: 'error',
              "data-testid": "bulk-failed-text"
            }, numberAndUnit(state.failed.size, itemName), " could not be", ' ', actionName, errorExtra != null ? " ".concat(errorExtra) : '')), state.errors.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
              style: {
                marginTop: '16px',
                marginBottom: '16px'
              },
              "data-testid": "bulk-failed-details"
            }, "Details:"), /*#__PURE__*/React.createElement("ul", {
              style: {
                marginLeft: '12px'
              }
            }, state.errors.map((error, index) => /*#__PURE__*/React.createElement("li", {
              style: {
                listStyle: 'disc'
              },
              key: index
            }, /*#__PURE__*/React.createElement(Typography, null, error)))))), /*#__PURE__*/React.createElement("div", {
              className: styles.progressBarBackground
            })),
            primaryButtonLabel: "Close",
            cancelButtonDisabled: bulkItemIds.length != state.succeeded + state.failed.size,
            primaryButtonDisabled: bulkItemIds.length != state.succeeded + state.failed.size,
            onPrimaryButtonClick: closeModal,
            onCloseButtonClick: closeModal
          });
        }
      }).then(failedItemIds => {
        onDone(failedItemIds);
      });
    }
  }
  return {
    doBulkAction
  };
}